// Offer list: GET /dmut/get-offer query builder, status metadata and the
// Excel/CSV export. Fetch and download helpers are shared with the Plan &
// Procurement list.

import { api } from '../../../config';
import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const OFFER_PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// `value` is the StatusOffering query value and the statusOfferingWording a
// row carries. `tone` drives the to-status / to-mcard modifier, `stat` the
// to-stat one.
export const OFFERING_STATUSES = [
  { value: 'Opening', icon: 'ri-door-open-line', tone: 'info', stat: 'open' },
  {
    value: 'Closing',
    icon: 'ri-hourglass-line',
    tone: 'muted',
    stat: 'muted',
  },
  {
    value: 'Past Deadline',
    icon: 'ri-timer-flash-line',
    tone: 'warning',
    stat: 'progress',
  },
];

// Same idea for SubmissionStatus. The filter only offers values the API
// accepts today; Submitted rows still render with their own tone.
export const SUBMISSION_STATUSES = [
  { value: 'Not Started', tone: 'muted', filterable: true },
  { value: 'Drafted', tone: 'info', filterable: true },
  { value: 'Submitted', tone: 'success', filterable: false },
];

export const getOfferingStatus = wording =>
  OFFERING_STATUSES.find(status => status.value === wording);

export const getSubmissionStatus = wording =>
  SUBMISSION_STATUSES.find(status => status.value === wording);

export const DEFAULT_SORT_FIELD = 'procurementNumber';

export const buildOfferListUrl = ({
  currentPage,
  rowsPerPage,
  procurementTypeHeader,
  search,
  statusOffering,
  submissionStatus,
  sortField,
  sortDirection,
}) => {
  const params = new URLSearchParams();
  params.set('PageNumber', String(currentPage));
  params.set('PageSize', String(rowsPerPage));
  params.set('ProcurementTypeHeader', procurementTypeHeader || '');
  if (sortField) {
    params.set('SortBy', sortField);
    params.set('IsDescending', sortDirection === 'desc' ? 'true' : 'false');
  }
  if (search) params.set('Search', search);
  if (statusOffering) params.set('StatusOffering', statusOffering);
  if (submissionStatus) params.set('SubmissionStatus', submissionStatus);
  return `${api.API_URL}/dmut/get-offer?${params.toString()}`;
};

// The detail page reads these from router state.
export const getDetailState = row => ({
  idOffer: row.idOffer,
  statusOfferingWording: row.statusOfferingWording,
  submissionStatusWording: row.submissionStatusWording,
  isLateSubmission: row.isLateSubmission,
});

const toExportRow = row => ({
  'ID Offer': row.idOffer || '',
  'ID Proc': row.procurementNumber || '',
  Title: row.titleProcurement || '',
  'Proc Type':
    OFFER_PROCUREMENT_TYPE_MAP[row.procurementType] ||
    row.procurementType ||
    '',
  Product: row.productType?.product?.name || '',
  'Product Type': getListProductTypeLabel(row, row.productType?.name) || '',
  Description: row.description || '',
  Offering: row.statusOfferingWording || '',
  Submission: row.submissionStatusWording || '',
  'Late Submit': row.isLateSubmission === true ? 'Yes' : '',
});

export const exportOfferList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(toExportRow), {
    format,
    prefix: 'Offer',
    sheetName,
  });
